<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">专家抽取</h2>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack"
                    size="small">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 内容区域 -->
        <div class="content-wrap">
            <el-form ref="expertForm" :model="expertForm" :rules="expertRules" label-width="140px"
                class="expert-form-grid">
                <!-- 基础信息区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-document"></i>
                        <span>基础信息</span>
                    </div>
                    <div class="section-content">
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="招标项目" prop="tenderProject">
                                    <el-input v-model="expertForm.tenderProject" placeholder="请输入招标项目"
                                        suffix-icon="el-icon-arrow-down" disabled />
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="8">
                                <el-form-item label="标段名称" prop="sectionName">
                                    <el-select v-model="expertForm.sectionName" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in sectionOptions" :key="item.sectionCode"
                                            :label="item.sectionName" :value="item.sectionCode" />
                                    </el-select>
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="8">
                                <!-- <el-form-item label="招标人">
                                    <el-input v-model="expertForm.tenderer" placeholder="请输入招标人" />
                                </el-form-item> -->
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <!-- <el-form-item label="代理机构">
                                    <el-input v-model="expertForm.agency" placeholder="请输入代理机构" />
                                </el-form-item> -->
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="审核流程">
                                    <el-select v-model="expertForm.approvalProcess" placeholder="请选择"
                                        style="width: 100%">
                                        <el-option v-for="item in approvalOptions" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="抽取人">
                                    <el-select v-model="expertForm.extractor" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in extractorOptions" :key="item.value"
                                            :label="item.label" :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- 专家库配置区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-user"></i>
                        <span>专家库配置</span>
                    </div>
                    <div class="section-content">
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item label="专家库" prop="expertPool">
                                    <el-radio-group v-model="expertForm.expertPool">
                                        <el-radio label="agency">代理专家库</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- 联系信息区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-phone"></i>
                        <span>联系信息</span>
                    </div>
                    <div class="section-content">
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="代理机构联系人" prop="agencyContact">
                                    <el-input v-model="expertForm.agencyContact" placeholder="请输入代理机构联系人" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系人电话" prop="agencyContactPhone">
                                    <el-input v-model="expertForm.agencyContactPhone" placeholder="请输入代理机构联系人电话" />
                                </el-form-item>
                            </el-col>
                           
                        </el-row>
                    </div>
                </div>
                <!-- 评标信息区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-time"></i>
                        <span>评标信息</span>
                    </div>
                    <div class="section-content">
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="评委会总数" prop="committeeTotal">
                                    <el-input v-model="expertForm.committeeTotal" placeholder="请输入评委会总数" />
                                </el-form-item>
                                <!-- <el-form-item label="预计评标时间">
                                    <el-radio-group v-model="expertForm.durationTime">
                                        <el-radio v-for="item in estimatedTimeOptions" :key="item.value"
                                            :label="item.value">
                                            {{ item.label }}
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item> -->
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="评标开始时间" prop="evaluationTime">
                                    <app-date-picker v-model="expertForm.evaluationTime" type="datetime"
                                        placeholder="请选择评标时间" style="width: 100%" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="评标地点" prop="evaluationLocation">
                                    <el-input v-model="expertForm.evaluationLocation" placeholder="请输入评标地点"
                                        maxlength="32" show-word-limit />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="招标人代表数量" prop="tendererRepresentativeCount">
                                    <el-input v-model="expertForm.tendererRepresentativeCount"
                                        placeholder="请输入招标人代表数量" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- 招标人代表信息区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-user-solid"></i>
                        <span>招标人代表信息</span>
                    </div>
                    <div class="section-content">
                        <el-table :data="expertForm.tendererRepresentatives" border>
                            <el-table-column prop="name" label="姓名">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.name" placeholder="请输入姓名" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="workUnit" label="工作单位">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.workUnit" placeholder="请输入工作单位" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="contact" label="联系方式">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.contact" placeholder="请输入联系方式" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="idCard" label="身份证号">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.idCard" placeholder="请输入身份证号" />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="150">
                                <template slot-scope="scope">
                                    <div class="action-buttons">
                                        <el-button type="primary" size="mini"
                                            @click="addTendererRepresentative(scope.$index)">添加</el-button>
                                        <el-button type="danger" size="mini"
                                            @click="removeTendererRepresentative(scope.$index)"
                                            v-if="scope.$index > 0">删除</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <!-- 抽取地区区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-location"></i>
                        <span>抽取地区</span>
                    </div>
                    <div class="section-content">
                        <div class="region-container">
                            <!-- 左侧：地区选择区域 -->
                            <div class="region-left">
                                <div class="region-selector">
                                    <div class="selector-row">
                                        <label class="selector-label">省/市：</label>
                                        <el-select v-model="selectedRegion1" placeholder="请选择省/市" style="width: 100%;"
                                            @change="handleRegionChange">
                                            <el-option v-for="region in regionOptions" :key="region.value"
                                                :label="region.label" :value="region.value" />
                                        </el-select>
                                    </div>
                                    <div class="selector-row">
                                        <label class="selector-label">市/区：</label>
                                        <el-select v-model="selectedRegion2" placeholder="请选择市/区" style="width: 100%;"
                                            @change="handleDistrictChange">
                                            <el-option v-for="city in cityOptions" :key="city.value" :label="city.label"
                                                :value="city.value" />
                                        </el-select>
                                    </div>
                                </div>
                                <div class="region-selection-area">
                                    <div class="selection-header">
                                        <i class="el-icon-check"></i>
                                        <span>选择区域</span>
                                    </div>
                                    <div class="selection-content">
                                        <div class="district-checkboxes" v-if="selectedRegion2">
                                            <el-checkbox-group v-model="selectedDistricts">
                                                <div class="checkbox-row" v-for="(row, index) in districtRows"
                                                    :key="index">
                                                    <el-checkbox v-for="district in row" :key="district.value"
                                                        :label="district.value" class="district-checkbox">
                                                        {{ district.label }}
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                        <div v-else class="empty-hint">
                                            <i class="el-icon-info"></i>
                                            <span>请先选择省份和城市</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="region-actions">
                                <el-button type="primary" icon="el-icon-plus" @click="addSelectedRegions"
                                    :disabled="selectedDistricts.length === 0" class="add-btn">
                                    添加
                                </el-button>
                            </div>
                            <!-- 右侧：已选择区域 -->
                            <div class="region-right">
                                <div class="selected-regions">
                                    <div class="selected-header">
                                        <div class="header-left">
                                            <span>已选择区域</span>
                                        </div>
                                        <el-button type="text" icon="el-icon-delete" @click="clearSelectedRegions"
                                            class="clear-btn" :disabled="finalSelectedRegions.length === 0">
                                            清除全部
                                        </el-button>
                                    </div>
                                    <div class="selected-content">
                                        <div v-if="finalSelectedRegions.length === 0" class="empty-selection">
                                            <i class="el-icon-location"></i>
                                            <p>暂无选择区域</p>
                                            <span>请在左侧选择区域后点击添加</span>
                                        </div>
                                        <div v-else class="selected-tags">
                                            <el-tag v-for="region in finalSelectedRegions" :key="region.id" closable
                                                @close="removeSelectedRegion(region.id)" class="region-tag" type="info">
                                                {{ region.label }}
                                            </el-tag>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 抽取专业区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-s-grid"></i>
                        <span>抽取专业</span>
                    </div>
                    <div class="section-content">
                        <el-table :data="expertExtractionList" border style="width: 100%">
                            <el-table-column prop="specialtyName" label="专业名称">
                                <template slot-scope="scope">
                                    <!-- 如果已有专业名称（编辑回显），直接显示文本 -->
                                    <div v-if="scope.row.specialtyName && scope.row.specialtyCode" class="specialty-display">
                                        <span>{{ scope.row.specialtyName }}</span>
                                        <el-button type="text" size="mini" @click="clearSpecialty(scope.row)" style="margin-left: 8px;">
                                            <i class="el-icon-close"></i> 清除
                                        </el-button>
                                    </div>
                                    <!-- 否则显示级联选择器 -->
                                    <el-cascader v-else :ref="`specialtyCascader${scope.$index}`" v-model="scope.row.specialty"
                                        placeholder="选择评标专业" :props="specialtyCascaderProps"
                                        @change="(val) => handleSpecialtyChange(val, scope.$index)" style="width: 100%"
                                        filterable />
                                </template>
                            </el-table-column>
                            <el-table-column prop="personNum" label="数量" width="150">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.personNum" :min="0" :max="scope.row.max"
                                        style="width: 100%"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="addExtractionItem">添加</el-button>
                                    <el-button v-if="expertExtractionList.length > 1" type="danger" size="mini"
                                        @click="removeExtractionItem(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <!-- 回避公司 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-office-building"></i>
                        <span>回避公司</span>
                    </div>
                    <div class="section-content">
                        <el-table :data="companyDtoList" border style="width: 100%">
                            <el-table-column prop="companyName" label="公司名称">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.companyName" placeholder="请输入公司名称"
                                        style="width: 100%"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="addCompanyItem">添加</el-button>
                                    <el-button v-if="companyDtoList.length > 1" type="danger" size="mini"
                                        @click="removeCompanyItem(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-form>
            <!-- 底部操作按钮 -->
            <div class="page-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { getSectionList, saveExpertSelection, getExpertSelection, getExpertCount } from '@/api/modules/expertSelection'
import { getNextLevelData } from '@/api/modules/base'
import areaData from 'china-area-data'

import areaData1 from 'element-china-area-data'



import RegionUtils from '@/utils/regionUtils'
export default {
    data() {
        return {
            id: '',
            committeeId: this.$route.query.committeeId,
            areaData: areaData,
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            // 表单数据
            expertForm: {
                tenderProject: "",
                sectionName: '',
                tenderer: '',
                agency: '',
                approvalProcess: '',
                extractor: '',
                expertPool: 'agency',
                // 新增字段
                agencyContact: '', // 代理机构联系人
                durationTime: '', // 预计评标时间
                committeeTotal: '', // 评委会总数
                agencyContactPhone: '', // 代理机构联系人电话
                evaluationTime: '', // 评标时间
                evaluationLocation: '', // 评标地点
                tendererRepresentativeCount: '', // 招标人代表数量
                // 表格数据
                tendererRepresentatives: [
                    {
                        name: '',
                        workUnit: '',
                        contact: '',
                        idCard: ''
                    }
                ] 
            },

            // 抽取地区相关
            selectedRegion1: '',
            selectedRegion2: '',
            selectedDistricts: [], // 选中的区县
            finalSelectedRegions: [], // 最终选择的区域列表

            // 抽取专业相关
            expertExtractionList: [
                {
                    specialty: [],  // 级联选择器的值
                    specialtyCode: '',  // 专业编码
                    specialtyName: '',  // 专业名称
                    personNum: 0,
                    max: 0
                }
            ],
            // 回避公司
            companyDtoList: [
                {
                    companyName: ''
                }

            ],

            // 表单验证规则
            expertRules: {
                tenderProject: [
                    { required: true, message: '请输入招标项目' }
                ],
                sectionName: [
                    { required: true, message: '请选择标段名称' }
                ],
                expertPool: [
                    { required: true, message: '请选择专家库' }
                ],
                // 新增字段验证规则
                agencyContact: [
                    { required: true, message: '请输入代理机构联系人' }
                ],
                durationTime: [
                    { required: true, message: '请选择预计评标时间' }
                ],
                committeeTotal: [
                    { required: true, message: '请输入评委会总数' }
                ],
                agencyContactPhone: [
                    { required: true, message: '请输入代理机构联系人电话' }
                ],
                evaluationTime: [
                    { required: true, message: '请选择评标时间' }
                ],
                evaluationLocation: [
                    { required: true, message: '请输入评标地点' }
                ],
                tendererRepresentativeCount: [
                    { required: true, message: '请输入招标人代表数量' }
                ]
            },
            // 下拉选项数据
            sectionOptions: [],
            // 区县市
            districtOptions: [
                { label: '市辖区', value: 'shixiaqu' },
                { label: '县', value: 'xian' },
                { label: '县级市', value: 'xianjishi' }
            ],
            // 地区选项 - 从china-area-data获取
            regionOptions: [],
            // 城市选项 - 根据选择的省份动态更新
            cityOptions: [],
            districtOptions1: [],
            // 当前选择的省市区
            selectedRegion1: '', // 省份code
            selectedRegion2: '', // 城市code
            // 专业选项 - 通过懒加载方式获取，不需要手动维护
            // 	审核流程:1仅内审
            approvalOptions: [
                {
                    value: 1,
                    label: '仅内审'
                }
            ],
            // 审核流程:1仅内审
            extractorOptions: [
                {
                    value: 1,
                    label: '本账号抽取'
                }
            ],
            estimatedTimeOptions: [
                {
                    value: 1,
                    label: '半天'
                },
                {
                    value: 2,
                    label: '一天'
                }
            ],
        }
    },

    computed: {
        // 将区县数据按3列分组显示
        districtRows() {
            const rows = [];
            if (this.districtOptions1 && this.districtOptions1.length > 0) {
                for (let i = 0; i < this.districtOptions1.length; i += 3) {
                    rows.push(this.districtOptions1.slice(i, i + 3));
                }
            }
            return rows;
        },

        // 专业分类级联选择器配置
        specialtyCascaderProps() {
            return RegionUtils.getCascaderProps('EXPERT_INDUSTRY_CODE')
        }
    },
    mounted() {
        //  如果路由中有ID 
        if (this.$route.query.id) {
            this.id = this.$route.query.id
            this.getExpertSelection()
        }
        this.getProjectInfo()
        this.getSectionList()
        this.initAreaData()
    },

    methods: {
        buildSpecialtyPathFromCode(industryCode) {
            if (!industryCode || typeof industryCode !== 'string') return []
            
            // 提取字母前缀（如 A、B、C）
            const prefixMatch = industryCode.match(/^[A-Za-z]+/)
            const prefix = prefixMatch ? prefixMatch[0] : ''
            
            if (!prefix) return []
            
            // 提取数字部分（如 01、0101）
            const digits = industryCode.slice(prefix.length)
            
            // 如果只有字母前缀，返回一级路径
            if (!digits || digits.length === 0) {
                return [prefix]
            }
            
            // 构建完整路径
            const path = [prefix]
            
            // 根据数字长度判断层级
            // 2位数字：二级（如 A01）
            // 4位数字：三级（如 A0101）
            // 6位数字：四级（如 A010101）
            if (digits.length >= 2) {
                path.push(prefix + digits.slice(0, 2))
            }
            if (digits.length >= 4) {
                path.push(prefix + digits.slice(0, 4))
            }
            if (digits.length >= 6) {
                path.push(prefix + digits.slice(0, 6))
            }
            
            return path
        },
        async backfillSpecialtySelections() {
            const list = Array.isArray(this.expertExtractionList) ? this.expertExtractionList : []
            for (let i = 0; i < list.length; i++) {
                const row = list[i]
                const code = row && row.specialtyCode
                if (!code) continue
                // 直接设置级联路径，懒加载会自动处理数据加载
                const path = this.buildSpecialtyPathFromCode(code)
                this.$set(row, 'specialty', path)

                try {
                    const res = await getExpertCount({ industryCode: code })
                    if (res.code === 200) {
                        this.$set(row, 'max', res.data)
                    }
                } catch (e) {
                    // ignore
                }
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 获取详情
        async getExpertSelection() {
            try {
                const res = await getExpertSelection({
                    id: this.id
                })
                if (res.code === 200) {
                    const data = res.data;

                    // 基础信息回显
                    this.expertForm.sectionName = data.sectionCodes && data.sectionCodes.length > 0 ? data.sectionCodes[0] : '';
                    this.expertForm.approvalProcess = data.reviewProcess;
                    this.expertForm.extractor = data.selectPerson;

                    // 联系信息回显
                    this.expertForm.agencyContact = data.contactName;
                    this.expertForm.agencyContactPhone = data.contactMobile;
                    this.expertForm.committeeTotal = data.representCount;

                    // 评标信息回显
                    this.expertForm.durationTime = data.durationTime;
                    this.expertForm.evaluationTime = data.reviewTime;
                    this.expertForm.evaluationLocation = data.address;
                    this.expertForm.tendererRepresentativeCount = data.representCount;

                    // 招标人代表信息回显
                    if (data.representList && data.representList.length > 0) {
                        this.expertForm.tendererRepresentatives = data.representList.map(item => ({
                            name: item.representName,
                            workUnit: item.workUnit,
                            contact: item.mobile,
                            idCard: item.idCard
                        }));
                    }

                    // 抽取地区回显
                    if (data.areaList && data.areaList.length > 0) {
                        this.finalSelectedRegions = data.areaList.map(item => ({
                            id: item.id,
                            provinceCode: item.provinceCode,
                            provinceName: item.provinceName,
                            cityCode: item.cityCode,
                            cityName: item.cityName,
                            countyCode: item.countyCode,
                            countyName: item.countyName,
                            label: `${item.provinceName} - ${item.cityName} - ${item.countyName}`
                        }));
                    }
                    // dictCode: "A" dictCode: "A01" dictCode: "A0101"
                    // 抽取专业回显
                    console.log(JSON.stringify(res.data.industryList));
                    
                    if (data.industryList && data.industryList.length > 0) {
                        this.expertExtractionList = data.industryList.map(item => ({
                            specialty: [],  // 级联选择器需要根据industryCode反向解析
                            specialtyCode: item.industryCode,
                            specialtyName: item.industryName,
                            personNum: item.personNum
                        }));
                    }
                    await this.backfillSpecialtySelections()
                     if (data.companyDtoList && data.companyDtoList.length > 0) {
                        this.companyDtoList = data.companyDtoList.map(item => ({
                            companyName: item.companyName,
                            id:item.id,
                            selectionMainId:item.selectionMainId

                        }));
                    }
                    
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                this.$message.error('网络异常')
            }
        },
        //获取列表
        async getSectionList() {
            try {
                const res = await getSectionList({
                    committeeId: this.committeeId
                })
                if (res.code === 200) {
                    let arr =[]
                    for (let index = 0; index < res.data.length; index++) {
                        const element = res.data[index];
                        element.sectionName = element.bidSectionName
                        element.sectionCode = element.bidSectionCode
                        arr.push(element);
                        
                    }
                    
                    this.sectionOptions = arr
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                this.$message.error('网络异常')
            }
        },
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
            this.expertForm.tenderProject = this.projectTitle.split("招标项目名称：")[1];
        },
        // 初始化地区数据
        initAreaData() {
            try {
                // 获取省份数据 (中国的省份数据在 '86' 下)
                const provinces = this.areaData['86'];
                console.log(JSON.stringify(provinces));
                this.regionOptions = Object.keys(provinces).map(code => ({
                    label: provinces[code],
                    value: code
                }));
            } catch (error) {
                console.error('初始化地区数据失败:', error);
            }
        },

        // 处理专业选择变化
        handleSpecialtyChange(value, index, cascaderRef) {
            if (value && value.length > 0) {
                // 获取最后一级的值作为专业编码
                this.expertExtractionList[index].specialtyCode = value[value.length - 1];
                // 获取专业名称
                this.$nextTick(() => {
                    const cascader = this.$refs[`specialtyCascader${index}`];
                    if (cascader && cascader.getCheckedNodes) {
                        const checkedNodes = cascader.getCheckedNodes();
                        if (checkedNodes && checkedNodes.length > 0) {
                            const specialtyCode = checkedNodes[0].value;
                            this.expertExtractionList[index].personNum = 0;
                            getExpertCount({ industryCode: specialtyCode }).then(res => {
                                if (res.code === 200) {
                                    this.$nextTick(() => {
                                        this.expertExtractionList[index].specialtyName = checkedNodes[0].label;
                                        this.expertExtractionList[index].max = res.data;
                                    });
                                } else {
                                    this.$message.error(res.msg || '获取验证码失败');
                                }
                            }).catch(error => {
                                console.error('发送验证码失败:', error);
                                this.$message.error('网络异常，请稍后重试');
                            });
                        }
                    }
                });
            }
        },

        // 清除已选择的专业
        clearSpecialty(row) {
            this.$set(row, 'specialty', [])
            this.$set(row, 'specialtyCode', '')
            this.$set(row, 'specialtyName', '')
            this.$set(row, 'personNum', 0)
            this.$set(row, 'max', 0)
        },



        // 处理省份选择变化
        handleRegionChange(provinceCode) {
            this.selectedRegion1 = provinceCode;
            this.selectedRegion2 = '';
            this.districtOptions1 = [];
            if (provinceCode && this.areaData[provinceCode]) {
                // 获取该省份下的城市数据
                const cities = this.areaData[provinceCode];
                this.cityOptions = Object.keys(cities).map(code => ({
                    label: cities[code],
                    value: code
                }));
                console.log(`${this.areaData['86'][provinceCode]} 的城市数据:`, this.cityOptions);
            } else {
                this.cityOptions = [];
            }
        },

        // 处理城市选择变化
        handleDistrictChange(cityCode) {
            this.selectedRegion2 = cityCode;
            if (cityCode && this.areaData[cityCode]) {
                // 获取该城市下的区县数据
                const districts = this.areaData[cityCode];
                this.districtOptions1 = Object.keys(districts).map(code => ({
                    label: districts[code],
                    value: code
                }));
                console.log(`${this.areaData[this.selectedRegion1][cityCode]} 的区县数据:`, this.districtOptions1);
            } else {
                this.districtOptions1 = [];
            }
        },
        // 添加选中的区域
        addSelectedRegions() {
            if (this.selectedDistricts.length === 0) {
                this.$message.warning('请先选择要添加的区域');
                return;
            }

            const provinceName = this.areaData['86'][this.selectedRegion1];
            const cityName = this.areaData[this.selectedRegion1][this.selectedRegion2];
// B010101
            // 获取选中的区县信息
            const selectedDistricts = this.selectedDistricts.map(districtCode => {
                const district = this.districtOptions1.find(d => d.value === districtCode);
                const districtName = district ? district.label : this.areaData[this.selectedRegion2][districtCode];
                // 格式化显示：省份-城市-区县
                const formattedLabel = `${provinceName}-${cityName}-${districtName}`;
                return {
                    id: Date.now() + Math.random(),
                    provinceCode: this.selectedRegion1,
                    provinceName: provinceName,
                    cityCode: this.selectedRegion2,
                    cityName: cityName,
                    countyCode: districtCode,
                    countyName: districtName,
                    label: formattedLabel
                };
            });

            // 添加到最终选择列表
            this.finalSelectedRegions.push(...selectedDistricts);
            // 清空当前选择
            this.selectedDistricts = [];
            this.$message.success('区域添加成功');
        },

        // 清除所有已选择的区域
        clearSelectedRegions() {
            this.finalSelectedRegions = [];
            this.$message.success('已清除所有选择区域');
        },
        // 移除单个已选择的区域
        removeSelectedRegion(regionId) {
            const index = this.finalSelectedRegions.findIndex(region => region.id === regionId);
            if (index > -1) {
                this.finalSelectedRegions.splice(index, 1);
            }
        },
        // 保存专家抽取
        handleSave() {
            this.$refs.expertForm.validate(async (valid) => {
                if (valid) {
                    // 验证抽取专业数量
                    const validSpecialties = this.expertExtractionList.filter(item => 
                        item.specialtyCode && item.specialtyName
                    )
                    
                    if (validSpecialties.length === 0) {
                        this.$message.warning('请至少添加一个抽取专业')
                        return
                    }
                    
                    // 检查每个专业的数量是否大于0
                    const invalidSpecialty = validSpecialties.find(item => 
                        !item.personNum || item.personNum <= 0
                    )
                    
                    if (invalidSpecialty) {
                        this.$message.warning(`专业"${invalidSpecialty.specialtyName}"的抽取数量必须大于0`)
                        return
                    }
                    
                    try {
                        // 构建提交数据
                        const submitData = this.buildSubmitData();
                        if (this.$route.query.id) {
                            submitData.id = this.id
                        }
                        const res = await saveExpertSelection(submitData);
                        if (res.code === 200) {
                            this.$message.success('保存成功');
                            this.$router.go(-1);
                        } else {
                            this.$message.error(res.msg || '保存失败');
                        }
                    } catch (error) {
                        console.error('保存失败:', error);
                        this.$message.error('网络异常');
                    }
                } else {
                    this.$message.error('请完善必填信息');
                }
            })
        },

        // 构建提交数据
        buildSubmitData() {
            // 构建区域列表 areaList
            const areaList = this.finalSelectedRegions.map(region => ({
                provinceCode: region.provinceCode,
                provinceName: region.provinceName,
                cityCode: region.cityCode,
                cityName: region.cityName,
                countyCode: region.countyCode,
                countyName: region.countyName
            }));

            // 构建行业列表 industryList，过滤掉未选择评标专业的项
            const industryList = this.expertExtractionList
                .filter(item => item.specialtyCode && item.specialtyName)
                .map(item => ({
                    industryCode: item.specialtyCode,
                    industryName: item.specialtyName,
                    personNum: item.personNum
                }));

            // 构建招标人代表列表 representList
            const representList = this.expertForm.tendererRepresentatives.map(rep => ({
                representName: rep.name,
                workUnit: rep.workUnit,
                mobile: rep.contact,
                idCard: rep.idCard
            }));

            // 过滤回避公司列表，去掉未输入公司名称的项
            const filteredCompanyList = this.companyDtoList.filter(company => 
                company.companyName && company.companyName.trim() !== ''
            );

            // 构建标段编码数组
            const sectionCodes = Array.isArray(this.expertForm.sectionName)
                ? this.expertForm.sectionName
                : [this.expertForm.sectionName];

            return {
                committeeId: this.committeeId,
                projectCode: this.projectCode,
                address: this.expertForm.evaluationLocation,
                areaList: areaList,
                contactName: this.expertForm.agencyContact,
                contactMobile: this.expertForm.agencyContactPhone,
                durationTime: this.expertForm.durationTime,
                industryList: industryList,
                representCount: parseInt(this.expertForm.tendererRepresentativeCount) || 0,
                representList: representList,
                reviewProcess: this.expertForm.approvalProcess === 'default' ? 1 : parseInt(this.expertForm.approvalProcess),
                reviewTime: this.expertForm.evaluationTime ? this.formatDateTime(this.expertForm.evaluationTime) : '',
                sectionCodes: sectionCodes,
                selectPerson: this.expertForm.extractor === 'current' ? 1 : parseInt(this.expertForm.extractor),
                companyDtoList: filteredCompanyList
            };
        },

        // 格式化日期时间
        formatDateTime(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = String(d.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        // 取消操作
        handleCancel() {
            this.$router.go(-1);
        },
        // 添加招标人代表
        addTendererRepresentative() {
            this.expertForm.tendererRepresentatives.push({
                name: '',       // representName
                workUnit: '',   // workUnit
                contact: '',    // mobile
                idCard: ''    // bankNum
            })
        },
        // 删除招标人代表
        removeTendererRepresentative(index) {
            this.expertForm.tendererRepresentatives.splice(index, 1)
        },
        // 添加抽取专业项
        addExtractionItem() {
            this.expertExtractionList.push({
                specialty: [],
                specialtyCode: '',
                specialtyName: '',
                personNum: 0
            })
        },
        // 删除抽取专业项
        removeExtractionItem(index) {
            if (this.expertExtractionList.length > 1) {
                this.expertExtractionList.splice(index, 1)
            }
        },
        // 添加回避公司项
        addCompanyItem() {
            this.companyDtoList.push({
                companyName: ''
            })
        },
        // 删除回避公司项
        removeCompanyItem(index) {
            if (this.companyDtoList.length > 1) {
                this.companyDtoList.splice(index, 1)
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

/* 专业名称显示样式 */
.specialty-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f0f7ff;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    
    span {
        flex: 1;
        color: #303133;
        font-size: 14px;
    }
    
    .el-button--text {
        color: #f56c6c;
        padding: 0;
        
        &:hover {
            color: #f78989;
        }
    }
}

/* 页面样式 */
.agent-page {
    padding: 20px;
}

.page-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

/* 内容区域样式 */
.content-wrap {
    width: 100%;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    border: 1px solid #e8e8e8;
    height: calc(100vh - 200px);
    overflow-y: auto;
}

/* 页面底部操作按钮 */
.page-footer {
    text-align: center;
    padding: 20px;
    background: white;

    .el-button {
        border-radius: 6px;
        font-weight: 500;
        margin: 0 10px;
    }
}

/* 表格部分样式 */
.table-section {
    margin-top: 30px;

    h4 {
        margin: 0 0 15px 0;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        padding-left: 10px;
    }

    .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h4 {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: #303133;
        }

        .el-button {
            margin-left: 10px;
        }
    }

    .action-buttons {
        display: flex;
        gap: 8px;
        align-items: center;

        .el-button {
            flex-shrink: 0;
        }
    }

    .table-actions {
        margin-top: 15px;
        text-align: left;

        .el-button {
            margin-right: 10px;
        }
    }
}


/* 抽取地区样式 - 现代化左右布局 */
.region-container {
    display: flex;
    gap: 24px;
    align-items: flex-start;

    .region-left {
        flex: 1;
        background: #fafbfc;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 20px;

        .region-selector {
            margin-bottom: 20px;

            .selector-row {
                display: flex;
                align-items: center;
                margin-bottom: 12px;

                &:last-child {
                    margin-bottom: 0;
                }

                .selector-label {
                    font-size: 14px;
                    color: #606266;
                    font-weight: 500;
                    min-width: 60px;
                    margin-right: 12px;
                }
            }
        }

        .region-selection-area {
            border: 1px solid #e4e7ed;
            border-radius: 6px;
            margin-bottom: 20px;
            background: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

            .selection-header {
                background-color: white;
                color: black;
                padding: 12px 16px;
                font-size: 14px;
                border-radius: 6px 6px 0 0;
                display: flex;
                align-items: center;

                i {
                    margin-right: 8px;
                    font-size: 16px;
                    color: black;
                }
            }

            .selection-content {
                padding: 16px;
                min-height: 120px;

                .district-checkboxes {
                    .checkbox-row {
                        display: flex;
                        flex-wrap: wrap;
                        margin-bottom: 8px;

                        .district-checkbox {
                            flex: 0 0 33.333%;
                            margin-bottom: 8px;
                            padding-right: 8px;

                            .el-checkbox__label {
                                font-size: 13px;
                                color: #606266;
                            }
                        }
                    }
                }

                .empty-hint {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 80px;
                    color: #909399;
                    font-size: 14px;

                    i {
                        margin-right: 8px;
                        font-size: 16px;
                    }
                }
            }
        }

        .region-actions {
            text-align: center;

            .add-btn {
                background-color: #667eea;
                border: none;
                border-radius: 6px;
                padding: 10px 24px;
                font-size: 14px;
                font-weight: 500;

                &:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                }

                &:disabled {
                    background: #c0c4cc;
                    box-shadow: none;
                    cursor: not-allowed;
                }
            }
        }
    }

    .region-right {
        flex: 1;

        .selected-regions {
            border: 1px solid #e4e7ed;
            border-radius: 8px;
            background: #fff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            height: 100%;

            .selected-header {
                color: black;
                padding: 12px 16px;
                border-radius: 8px 8px 0 0;
                display: flex;
                background-color: white;
                justify-content: space-between;
                align-items: center;

                .header-left {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 8px;
                        font-size: 16px;
                        color: black;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 500;
                        margin-right: 8px;
                    }

                    .count-badge {
                        .el-badge__content {
                            background: rgba(255, 255, 255, 0.2);
                            border: 1px solid rgba(255, 255, 255, 0.3);
                            color: #fff;
                        }
                    }
                }

                .clear-btn {
                    color: black;
                    font-size: 12px;
                }
            }

            .selected-content {
                padding: 20px;
                min-height: 200px;

                .empty-selection {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 160px;
                    color: #909399;
                    text-align: center;

                    i {
                        font-size: 48px;
                        margin-bottom: 12px;
                        opacity: 0.5;
                    }

                    p {
                        font-size: 16px;
                        margin: 0 0 8px 0;
                        font-weight: 500;
                    }

                    span {
                        font-size: 14px;
                        opacity: 0.8;
                    }
                }

                .selected-tags {
                    .region-tag {
                        margin: 6px 8px 6px 0;
                        border-radius: 16px;
                        padding: 0px 12px;
                        font-size: 13px;
                        background: #f0f9ff;
                        border: 1px solid #b3d8ff;
                        color: #409eff;
                        transition: all 0.3s ease;

                        &:hover {
                            background: #e1f3ff;
                            transform: translateY(-1px);
                            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
                        }

                        .el-tag__close {
                            color: #409eff;

                            &:hover {
                                background: #409eff;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
}

// 抽取专业表格样式
.expert-extraction-section {
    margin-top: 20px;

    .section-title {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        min-width: 80px;
        padding-top: 8px;
    }
}

/* 网格布局样式 */
.expert-form-grid {
    .form-section {
        background: #fafafa;
        overflow: hidden;
        text-align: start;

        .section-title {
            background-color: white;
            color: black;
            padding: 12px 20px;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 0;

            i {
                font-size: 18px;
                color: black;
            }
        }

        .section-content {
            padding: 20px;
            background: white;
        }
    }
}
</style>